export default __webpack_public_path__ + "static/media/convert-ecredit-to-epoint-step1.3220fc0e.png";